import axios from "axios";

const elasticSearchApiInstance = axios.create({
  baseURL: `${process.env.VUE_APP_ELASTICSEARCH_ENDPOINT}${process.env.VUE_APP_ELASTICSEARCH_INDEX}`,
  auth: {
    username: process.env.VUE_APP_ELASTICSEARCH_USERNAME,
    password: process.env.VUE_APP_ELASTICSEARCH_PASSWORD,
  }
});

export const elasticSearchFilterApiInstance = axios.create({
  baseURL: `${process.env.VUE_APP_ELASTICSEARCH_ENDPOINT}${process.env.VUE_APP_ELASTICSEARCH_FILTER_INDEX}`,
  auth: {
    username: process.env.VUE_APP_ELASTICSEARCH_USERNAME,
    password: process.env.VUE_APP_ELASTICSEARCH_PASSWORD,
  }
});

export const elasticSearchIndustryApiInstance = axios.create({
  baseURL: `${process.env.VUE_APP_ELASTICSEARCH_ENDPOINT}${process.env.VUE_APP_ELASTICSEARCH_INDUSTRY_INDEX}`,
  auth: {
    username: process.env.VUE_APP_ELASTICSEARCH_USERNAME,
    password: process.env.VUE_APP_ELASTICSEARCH_PASSWORD,
  }
});

export const dataSize = 10000;

export const casesTabFilterAggs = (/* ind, subInd */) => ({
  // industries: {
  //   terms: {
  //     field: 'industries.GroupShort.keyword',
  //     size: ind || subInd ? 1 : dataSize * 10,
  //     include: ind ? [ind] : [],
  //   },
  //   aggs: {
  //     data_bucket_sort: {
  //       bucket_sort: {
  //         sort: [{ _count: { order: "desc" } }]
  //       }
  //     }
  //   }
  // },
  // subIndustries: {
  //   terms: {
  //     field: 'industries.CodeDesc.keyword',
  //     size: subInd ? 1 : dataSize * 10,
  //     include: subInd ? [subInd] : [],
  //   },
  //   aggs: {
  //     data_bucket_sort: {
  //       bucket_sort: {
  //         sort: [{ _count: { order: "desc" } }]
  //       }
  //     }
  //   }
  // },
  // companies: {
  //   terms: { field: 'companies.name.keyword', size: dataSize * 10 },
  // },

  results: {
    terms: {
      size: dataSize,
      field: 'result.keyword',
    },
  },
  pointOfLaws: {
    terms: {
      size: dataSize,
      field: 'category.keyword',
    },
  },
  judges: {
      terms : {
        size : 10000,
        field : "heardBefore.name.keyword"
      },
  },
  caseTypes: {
    terms: {
      size: dataSize,
      field: 'caseType.keyword',
    },
  },
});

export const getOnlyIndustries = {
  industries: {
    terms: {
      field: 'claimant.company.Industries.GroupShort.keyword',
      size: dataSize * 10, 
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _key: { order: "asc" } }]
        }
      }
    }
  }
};

export const getOnlyRespondentIndustries = {
  industries: {
    terms: {
      field: 'respondent.company.Industries.GroupShort.keyword',
      size: dataSize * 10, 
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _key: { order: "asc" } }]
        }
      }
    }
  }
};

export const getOnlySubIndustries = {
  subIndustries: {
    terms: {
      field: 'claimant.company.Industries.CodeDesc.keyword',
      size: dataSize * 10,
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _key: { order: "asc" } }]
        }
      }
    }
  }
};

export const getOnlyRespondentSubIndustries = {
  subIndustries: {
    terms: {
      field: 'respondent.company.Industries.CodeDesc.keyword',
      size: dataSize * 10,
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _key: { order: "asc" } }]
        }
      }
    }
  }
};

export const getRespondentInstructers = {
  instructers: {
    terms: {
      field: 'respondent.representations.instructedBy.keyword',
      size: dataSize * 10, 
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _key: { order: "asc" } }]
        }
      }
    }
  }
};

export const getClaimentInstructers = {
  instructers: {
    terms: {
      field: 'claimant.representations.instructedBy.keyword',
      size: dataSize * 10, 
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _key: { order: "asc" } }]
        }
      }
    }
  }
};



export const casesTabChartFilterAggs = {
  casesByTimeline: {
    date_histogram: {
      field: "startDate",
      calendar_interval: "year"
    }
  },
  caseByTypes: {
    terms: {
      size: dataSize,
      field: "caseType.keyword",
    }
  },
  caseByResults: {
    terms: {
      size: dataSize,
      field: "result.keyword",
    }
  },
  claimantInstructed: {
    terms: {
      size: 500,
      field: "claimant.representations.instructedBy.keyword",
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _count: { order: "desc" } }]
        }
      }
    }
  },
  respondentInstructed: {
    terms: {
      size: 500,
      field: "respondent.representations.instructedBy.keyword",
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _count: { order: "desc" } }]
        }
      }
    }
  },
  claimantInstructedAll: {
    terms: {
      size: dataSize,
      field: "claimant.representations.instructedBy.keyword",
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _count: { order: "desc" } }]
        }
      }
    }
  },
  respondentInstructedAll: {
    terms: {
      size: dataSize,
      field: "respondent.representations.instructedBy.keyword",
    },
    aggs: {
      data_bucket_sort: {
        bucket_sort: {
          sort: [{ _count: { order: "desc" } }]
        }
      }
    }
  },
};

export const predictionsTabFilterAggs = {
  // industries: {
  //   terms: { field: 'industries.GroupShort.keyword', size: dataSize * 10 },
  // },
  // subIndustries: {
  //   terms: { field: 'industries.CodeDesc.keyword', size: dataSize * 10 },
  // },
  caseByResults: {
    terms: {
      size: dataSize,
      field: "result.keyword",
    }
  },
  pointOfLaws: {
    terms: { field: 'category.keyword', size: dataSize },
  },
};

export const getSimilarCaseFilter = (index, docId) => ({
  size: 5,
  query: {
    more_like_this: {
      fields: [
        "caseNo",
        "caseName",
        "caseType",
        "category",
        "subcategory",
        "source",
        "claimant",
        "respondent",
        "country",
        "decision",
        "result",
        "city"
      ],
      like: [{ _index: index, _id: docId }],
      min_term_freq: 1,
      max_query_terms: 25,
      min_doc_freq: 1,
      max_doc_freq: 1000,
      min_word_length: 2
    }
  },
  _source: ["caseNo", "caseName", "startDate"]
});

export default elasticSearchApiInstance;